export default __webpack_public_path__ + "static/media/Pleb-Pepe.91d79ea6.svg";